/* eslint-disable react/prop-types */
import { Icon } from "@iconify/react";
import { Button, Flex, Popconfirm } from "antd";
import pallete from "../utils/pallete";
import RenderIf from "./RenderIf";

export default function TableAction({ onClickEdit, handleDelete, deleteLoading, deleteDisabled = false, showDelete = true, showEdit = true }) {

  return (
    <Flex gap={10} justify="end" >
      <RenderIf when={showEdit}>
        <Button
          icon={<Icon icon="solar:pen-2-bold-duotone" width="18" height="18" />}
          color="blue"
          variant="filled"
          style={{
            padding: '0 8px',
          }}
          onClick={onClickEdit}
          size=""
        />
      </RenderIf>
      <RenderIf when={showDelete} >
        <Popconfirm
          placement="right"
          title="Pemberitahuan"
          description="Yakin ingin menghapus data ini?"
          okText="Hapus"
          cancelText="Tidak"
          // icon={<AlertCircle color="red" strokeWidth={1.2} style={{ marginRight: 6 }} />}
          onConfirm={handleDelete}
          okButtonProps={{
            loading: deleteLoading,
            danger: true,
          }}
        >
          <Button
            disabled={deleteDisabled}
            variant="filled"
            color="danger"
            icon={<Icon icon="solar:trash-bin-trash-bold-duotone" width="18" height="18" />}
            size=""
            style={{
              padding: '0 8px',
            }}
          />
        </Popconfirm>
      </RenderIf>
    </Flex>
  )
}